// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-game-jsx": require("gatsby-module-loader?name=component---src-pages-game-jsx!/opt/build/repo/src/pages/game.jsx"),
  "component---src-pages-index-jsx": require("gatsby-module-loader?name=component---src-pages-index-jsx!/opt/build/repo/src/pages/index.jsx")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "game.json": require("gatsby-module-loader?name=path---game!/opt/build/repo/.cache/json/game.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/opt/build/repo/.cache/json/index.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-jsx!/opt/build/repo/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js